function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from '../../_snowpack/pkg/react.js';
import { Controller, useFieldArray, useForm } from '../../_snowpack/pkg/react-hook-form.js';
import Select from '../../_snowpack/pkg/react-select.js';
import { toast } from '../../_snowpack/pkg/react-toastify.js';
import api from '../api/index.js';
import { useUpdateOrder } from '../hooks/index.js';
import { useStore } from '../stores/index.js';
import { formatCurrency, formatDate, mapToSelectValue, mapToSelectValues } from '../utils/utils.js';
import { jsx as __cssprop } from "../../_snowpack/pkg/@emotion/react.js";
export default function OrderForm({
  orderId,
  onCancel
}) {
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [order, setOrder] = useState({});
  const {
    control,
    handleSubmit,
    reset,
    register
  } = useForm();
  const store = useStore();
  const mutUpdateOrder = useUpdateOrder();
  useEffect(() => {
    let unmounted = false;
    api.getOrder(orderId).then(data => {
      if (!unmounted) {
        setOrder(data);
        reset({
          ...data,
          tags: mapToSelectValues(store.tags, data.tags),
          deliveryMethod: mapToSelectValue(store.deliveryMethods, data.deliveryMethod),
          status: mapToSelectValue(store.orderStatuses, data.status),
          shippingAddress: {
            ...data.shippingAddress,
            ageRange: mapToSelectValue(store.ageRanges, data.shippingAddress.ageRange),
            gender: mapToSelectValue(store.genders, data.shippingAddress.gender)
          }
        });
      }
    }).finally(() => {
      if (!unmounted) {
        setLoading(false);
      }
    });
    return function () {
      unmounted = true;
    };
  }, []);
  const onSubmit = data => {
    let formData = {
      ...data,
      deliveryMethod: data.deliveryMethod?.value,
      status: data.status?.value,
      account: data.account?.value,
      tags: data.tags?.map(item => item.value),
      shippingAddress: {
        ...data.shippingAddress,
        ageRange: data.shippingAddress.ageRange?.value,
        gender: data.shippingAddress.gender?.value
      }
    };
    setSaving(true);
    mutUpdateOrder.mutateAsync(formData).then(() => {
      toast.success('Record updated!');
      store.setLastSelectedOrderId(formData.id);
      store.setSelectedOrderId(null);
    }).catch(error => {
      toast.error(error.message);
    }).finally(() => {
      setSaving(false);
    });
  };
  if (loading) {
    return __cssprop(Spinner, null);
  }
  return __cssprop("div", {
    id: "ts-form-update",
    className: "thermal-form",
    css: {
      "position": "relative"
    }
  }, saving && __cssprop("div", {
    css: {
      "width": "100%",
      "height": "100%",
      "position": "absolute",
      "--tw-bg-opacity": "0.3",
      "backgroundColor": "rgba(107, 114, 128, var(--tw-bg-opacity))",
      "zIndex": "50"
    }
  }, __cssprop(Spinner, {
    label: "Saving..."
  })), __cssprop("form", {
    onSubmit: handleSubmit(onSubmit),
    noValidate: true,
    css: {
      "paddingLeft": "0.5rem",
      "paddingRight": "0.5rem",
      "paddingTop": "1.5rem",
      "paddingBottom": "1.5rem"
    }
  }, __cssprop("div", {
    css: {
      "display": "flex"
    }
  }, __cssprop("div", {
    css: {
      "width": "33.333333%",
      "display": "flex",
      "flexDirection": "column"
    }
  }, __cssprop(Field, {
    label: "Order #"
  }, order.orderNumber), __cssprop(Field, {
    label: "Account"
  }, order.account), __cssprop(Field, {
    label: "Order Date"
  }, formatDate(order.orderDate, 'LLL d, yyyy, hh:mm aa'))), __cssprop("div", {
    css: {
      "width": "66.666667%",
      "display": "flex",
      "flexDirection": "column"
    }
  }, __cssprop(Field, {
    label: "Order Status"
  }, __cssprop(Controller, {
    name: "status",
    control: control,
    render: ({
      field
    }) => __cssprop(Select, _extends({}, field, {
      options: store.orderStatuses,
      placeholder: "Order Status"
    }))
  })), __cssprop(Field, {
    label: "Tags",
    fullWidth: true
  }, __cssprop(Controller, {
    name: "tags",
    control: control,
    render: ({
      field
    }) => __cssprop(Select, _extends({}, field, {
      options: store.tags,
      isMulti: true,
      placeholder: "Tags",
      css: {
        "minWidth": "150px"
      },
      closeMenuOnSelect: false
    }))
  })))), __cssprop("div", {
    css: {
      "display": "flex",
      "marginTop": "1rem"
    }
  }, __cssprop("div", {
    css: {
      "width": "33.333333%"
    }
  }, __cssprop(SectionName, {
    label: "Buyer Info"
  }), __cssprop(Field, {
    label: "Buyer Name"
  }, order.billingAddress.fullName), __cssprop(Field, {
    label: "Buyer Address"
  }, order.billingAddress.address1), __cssprop(Field, {
    label: "Buyer City"
  }, order.billingAddress.city), __cssprop(Field, {
    label: "Buyer State"
  }, order.billingAddress.state), __cssprop(Field, {
    label: "Buyer Zip"
  }, order.billingAddress.zipPostalCode), __cssprop(Field, {
    label: "Products",
    fullWidth: true
  }, order.orderItems.map(item => __cssprop("div", {
    key: item.id
  }, __cssprop("span", null, item.quantity, " x"), __cssprop("span", {
    css: {
      "marginLeft": "0.5rem",
      "marginRight": "0.5rem"
    }
  }, item.productName), item.attributes && __cssprop("span", null, "- Size: ", item.attributes.size)))), __cssprop(Field, {
    label: "Order Total"
  }, __cssprop("span", {
    css: {
      "--tw-text-opacity": "1",
      "color": "rgba(239, 68, 68, var(--tw-text-opacity))",
      "fontWeight": "700"
    }
  }, formatCurrency(order.orderTotal))), __cssprop(Field, {
    label: "Sales Tax"
  }, formatCurrency(order.salesTax)), __cssprop(Field, {
    label: "Cust Shipping Cost"
  }, __cssprop("input", _extends({
    type: "number",
    placeholder: "Cust Shipping Cost",
    className: "form-control"
  }, register('customerShippingCost')))), __cssprop(Field, {
    label: "Discount"
  }, __cssprop("input", _extends({
    type: "number",
    placeholder: "Discount",
    className: "form-control"
  }, register('orderDiscount')))), __cssprop(Field, {
    label: "Seller Fee"
  }, __cssprop("input", _extends({
    type: "number",
    placeholder: "Shipping Cost",
    className: "form-control"
  }, register('sellerFee'))))), __cssprop("div", {
    css: {
      "width": "33.333333%"
    }
  }, __cssprop(SectionName, {
    label: "Customer Info"
  }), __cssprop(Field, {
    label: "Customer Name"
  }, order.shippingAddress.fullName), __cssprop(Field, {
    label: "Customer Address"
  }, order.shippingAddress.address1), __cssprop(Field, {
    label: "Customer City"
  }, order.shippingAddress.city), __cssprop(Field, {
    label: "Customer State"
  }, order.shippingAddress.state), __cssprop(Field, {
    label: "Customer Zip"
  }, order.shippingAddress.zipPostalCode), __cssprop(Field, {
    label: "Customer Age"
  }, __cssprop(Controller, {
    name: "shippingAddress.ageRange",
    control: control,
    render: ({
      field
    }) => __cssprop(Select, _extends({}, field, {
      options: store.ageRanges,
      placeholder: "Age"
    }))
  })), __cssprop(Field, {
    label: "Customer Gender"
  }, __cssprop(Controller, {
    name: "shippingAddress.gender",
    control: control,
    render: ({
      field
    }) => __cssprop(Select, _extends({}, field, {
      options: store.genders
    }))
  }))), __cssprop("div", {
    css: {
      "width": "33.333333%"
    }
  }, __cssprop(SectionName, {
    label: "Shipping Info",
    alignRight: false
  }), __cssprop(Field, {
    label: "Delivery Method"
  }, __cssprop(Controller, {
    name: "deliveryMethod",
    control: control,
    render: ({
      field
    }) => __cssprop(Select, _extends({}, field, {
      options: store.deliveryMethods
    }))
  })), __cssprop(Field, {
    label: "Tracking Number"
  }, __cssprop("input", _extends({
    type: "text",
    placeholder: "Tracking Number",
    className: "form-control"
  }, register('trackingNumber')))), __cssprop(Field, {
    label: "Shipping Cost"
  }, __cssprop("input", _extends({
    type: "number",
    placeholder: "Shipping Cost",
    className: "form-control"
  }, register('shippingCost')))), __cssprop(SectionName, {
    label: "Notes",
    alignRight: false
  }), __cssprop(Notes, {
    control: control
  }))), __cssprop("div", {
    css: {
      "display": "flex",
      "justifyContent": "center",
      "> :not([hidden]) ~ :not([hidden])": {
        "--tw-space-x-reverse": 0,
        "marginRight": "calc(0.5rem * var(--tw-space-x-reverse))",
        "marginLeft": "calc(0.5rem * calc(1 - var(--tw-space-x-reverse)))"
      },
      "marginTop": "1rem"
    }
  }, __cssprop("button", {
    type: "submit",
    className: "btn btn-primary"
  }, __cssprop("span", {
    className: "glyphicon-left glyphicon glyphicon-send"
  }), __cssprop("span", {
    css: {
      "marginLeft": "0.75rem"
    }
  }, "Save")), __cssprop("button", {
    type: "button",
    className: "btn btn-danger",
    onClick: onCancel
  }, __cssprop("span", {
    className: "glyphicon-left glyphicon glyphicon-remove"
  }), __cssprop("span", {
    css: {
      "marginLeft": "0.75rem"
    }
  }, "Cancel")))));
}
const Spinner = ({
  label = 'Loading...'
}) => {
  return __cssprop("div", {
    css: {
      "width": "100%",
      "height": "24rem",
      "justifyContent": "center",
      "alignItems": "center",
      "display": "flex",
      "fontWeight": "600",
      "fontSize": "3rem",
      "lineHeight": "1"
    },
    className: "spinner-text-5xl"
  }, __cssprop("span", {
    className: "glyphicon glyphicon-refresh glyphicon-refresh-animate"
  }), __cssprop("span", {
    css: {
      "marginLeft": "1rem"
    }
  }, label));
};
const Field = ({
  label,
  children,
  fullWidth = false
}) => {
  return __cssprop("div", {
    css: {
      "display": "flex",
      "alignItems": "center",
      "marginBottom": "1rem"
    }
  }, __cssprop("div", {
    css: {
      "width": "16rem",
      "fontWeight": "700",
      "textAlign": "right",
      "marginRight": "1.5rem"
    }
  }, label), __cssprop("div", {
    css: [!fullWidth && {
      "minWidth": "150px"
    }]
  }, children));
};
const SectionName = ({
  label,
  alignRight = true
}) => {
  return __cssprop("div", {
    css: [{
      "marginBottom": "1.25rem",
      "width": "16rem"
    }, alignRight && {
      "textAlign": "right"
    }]
  }, __cssprop("h2", {
    css: {
      "fontWeight": "700",
      "fontSize": "1.5rem",
      "lineHeight": "2rem",
      "--tw-text-opacity": "1",
      "color": "rgba(37, 99, 235, var(--tw-text-opacity))"
    }
  }, label));
};
const Notes = ({
  control
}) => {
  const {
    fields,
    remove,
    prepend
  } = useFieldArray({
    control,
    name: 'orderNotes',
    keyName: 'uniqueId'
  });
  const [newNote, setNewNote] = useState('');
  const handleAdd = () => {
    prepend({
      note: newNote
    });
    setNewNote('');
  };
  return __cssprop("div", {
    css: {
      "--tw-bg-opacity": "1",
      "backgroundColor": "rgba(255, 255, 255, var(--tw-bg-opacity))",
      "borderRadius": "0.5rem",
      "overflow": "hidden"
    }
  }, __cssprop("div", {
    css: {
      "maxHeight": "16rem",
      "overflowY": "scroll"
    },
    className: "notes-table"
  }, __cssprop("table", {
    className: "table"
  }, __cssprop("thead", null, __cssprop("tr", null, __cssprop("th", null, "#"), __cssprop("th", null, "Note"), __cssprop("th", null))), __cssprop("tbody", null, fields.map((item, index) => __cssprop("tr", {
    key: item.uniqueId
  }, __cssprop("td", {
    css: {
      "width": "3rem"
    }
  }, index + 1), __cssprop("td", null, item.note), __cssprop("td", null, /[^0-9]/.test(item.id) && __cssprop("button", {
    type: "button",
    css: {
      "--tw-text-opacity": "1",
      "color": "rgba(220, 38, 38, var(--tw-text-opacity))",
      "fontWeight": "700"
    },
    onClick: () => remove(index)
  }, "x"))))))), __cssprop("div", {
    css: {
      "display": "flex",
      "padding": "0.75rem",
      "justifyContent": "flex-start",
      "alignItems": "flex-start",
      "> :not([hidden]) ~ :not([hidden])": {
        "--tw-space-x-reverse": 0,
        "marginRight": "calc(0.5rem * var(--tw-space-x-reverse))",
        "marginLeft": "calc(0.5rem * calc(1 - var(--tw-space-x-reverse)))"
      }
    }
  }, __cssprop("div", {
    css: {
      "width": "100%",
      "borderRadius": "0.25rem"
    }
  }, __cssprop("textarea", {
    rows: 2,
    maxLength: 1000,
    css: {
      "width": "100%",
      "padding": "0.75rem",
      "borderRadius": "0.25rem",
      "borderWidth": "1px"
    },
    placeholder: "New note for this order",
    value: newNote,
    onChange: e => setNewNote(e.target.value)
  })), __cssprop("button", {
    type: "button",
    disabled: !newNote,
    className: "btn btn-default flex-shrink-0 flex-grow-0",
    onClick: () => handleAdd()
  }, "Add")));
};